import { useComponent, useLocale, useService, useWidget } from "../../../hooks";

export const Subscription = () => {
  const { t } = useLocale();
  const Banner = useWidget("Banner");
  const SubscriptionData = useComponent("SubscriptionData");
  const { getActiveSubscription } = useService("User");
  const { setTitle } = useService("Meta");
  setTitle(t("userSubscriptions"));

  return (
    <>
      <Banner title="Subscriptions" image="header-car-back.jpg" />
      <div className="pricing-page subscription">
        <div className="jumbo-container">
          <div className="heading-section-pricing">
            <h1 className="heading-table-price">
              {t("data.subscribersHubTile")}
            </h1>
            <p>{t("subscribersHubCondition")}</p>
            <SubscriptionData activeSubscription={getActiveSubscription()} />
          </div>
        </div>
      </div>
    </>
  );
};
